import {Form, Modal} from 'antd';
import {PaymentMethods, useProvidersQuery, useRegisterMoneiXpMerchantMutation} from 'api/generated';
import {ErrorMessage, Formik} from 'formik';
import {FormItem, Select} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import React from 'react';
import styled from 'styled-components';
import * as yup from 'yup';

type Props = {
  accountId: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const PPRO_OPTIONS = {
  alipay: 'Alipay',
  bancontact: 'Bancontact',
  eps: 'EPS',
  mbway: 'MB Way',
  multibanco: 'Multibanco',
  sepa: 'SEPA',
  trustly: 'Trustly'
};

const ErrorText = styled.div`
  color: red;
`;

const validationSchema = yup.object().shape({
  allowedPaymentMethods: yup.array().min(1, 'Select at least one payment method')
});

export const RegisterPproModal: React.FC<Props> = ({accountId, isOpen, setIsOpen}) => {
  const [register] = useRegisterMoneiXpMerchantMutation();
  const {data: {providers} = {}} = useProvidersQuery({
    variables: {accountId: accountId}
  });

  const usedPaymentMethods = providers?.map((provider) => provider.paymentMethod);

  if (!accountId) return null;

  const initialValues = {
    allowedPaymentMethods: []
  };

  const handleSubmit = async (
    {allowedPaymentMethods}: typeof initialValues,
    {setSubmitting}: FormikHelpers<typeof initialValues>
  ) => {
    try {
      await register({
        variables: {
          accountId: accountId,
          paymentMethods: allowedPaymentMethods as PaymentMethods[]
        }
      });
      setIsOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}>
        {({submitForm, isSubmitting, resetForm, errors}) => (
          <Modal
            title="Are you sure?"
            okText="Confirm"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            afterClose={resetForm}
            onCancel={() => {
              setIsOpen(false);
            }}>
            <Form layout="vertical">
              <FormItem name="reason" label="Allowed payment methods" hasFeedback={false}>
                <Select
                  name="allowedPaymentMethods"
                  mode="multiple"
                  optionFilterProp="label"
                  status={errors.allowedPaymentMethods ? 'error' : undefined}
                  options={Object.entries(PPRO_OPTIONS)
                    .filter(([value]) => !usedPaymentMethods?.includes(value as PaymentMethods))
                    .map(([value, label]) => ({
                      label,
                      value
                    }))}></Select>
                <ErrorText>
                  <ErrorMessage name="allowedPaymentMethods" />
                </ErrorText>
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
